import { useEffect, useState } from "react";

// The chosen microphone is remembered in this browser. Empty = the system default.
const KEY = "observer.micId";

export const loadMicId = () => {
  try {
    return localStorage.getItem(KEY) || "";
  } catch {
    return "";
  }
};

export const saveMicId = (id) => {
  try {
    if (id) localStorage.setItem(KEY, id);
    else localStorage.removeItem(KEY);
  } catch {
    /* remembering is a convenience */
  }
};

// Microphones on this device. Browsers hide their names until mic access is granted, so the list is read again once
// a stream is live, and whenever a device is plugged in or removed.
export function useMics(stream) {
  const [mics, setMics] = useState([]);
  useEffect(() => {
    const md = navigator.mediaDevices;
    if (!md?.enumerateDevices) return undefined;
    let alive = true;
    const read = () => md.enumerateDevices().then((all) => {
      if (!alive) return;
      // "default" and "communications" are Chrome's aliases for real devices that are listed anyway.
      setMics(all.filter((d) => d.kind === "audioinput" && d.deviceId && !["default", "communications"].includes(d.deviceId))
        .map((d, i) => ({ id: d.deviceId, label: d.label || `Microphone ${i + 1}` })));
    }).catch(() => {});
    read();
    md.addEventListener?.("devicechange", read);
    return () => {
      alive = false;
      md.removeEventListener?.("devicechange", read);
    };
  }, [stream]);
  return mics;
}
